// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class ClientWorkflowModuleCatalog {
    static ClientServerStatusModule: IWorkflowModuleConfig = {
        name: "services_status",
        modulePath: PLATFORM.moduleName("modules/workflows/Client/Status/ClientServerStatusModule"),
        title: "Sorama Services",
        moduleType: WorkflowModuleType.Client,
    };
    static ClientUpdateModule: IWorkflowModuleConfig = {
        name: "update",
        modulePath: PLATFORM.moduleName("modules/workflows/Client/Update/ClientUpdateModule"),
        title: "Service Update",
        moduleType: WorkflowModuleType.Client,
    };
    static DeviceFirmwareUpdateModule: IWorkflowModuleConfig = {
        name: "device_firmware_update",
        modulePath: PLATFORM.moduleName("modules/workflows/Client/DeviceFirmwareUpdate/DeviceFirmwareUpdateModule"),
        title: "Device Firmware Update",
        moduleType: WorkflowModuleType.Client,
    };
    static DeviceRecoveryModule: IWorkflowModuleConfig = {
        name: "device_recovery",
        modulePath: PLATFORM.moduleName("modules/workflows/Client/DeviceRecovery/DeviceRecoveryModule"),
        title: "Device Recovery",
        moduleType: WorkflowModuleType.Client,
    };
    static SupportedBrowsersModule: IWorkflowModuleConfig = {
        name: "supported_browsers",
        modulePath: PLATFORM.moduleName("modules/workflows/Support/SupportedBrowsers/SupportedBrowsersModule"),
        title: "Supported Browsers",
        moduleType: WorkflowModuleType.Client,
    };
    static MotionRestApiModule: IWorkflowModuleConfig = {
        name: "motionrestapi",
        modulePath: PLATFORM.moduleName("modules/workflows/Motion/RestApi/MotionRestApiModule"),
        title: "Motion REST API",
        moduleType: WorkflowModuleType.Client,
    };

    static DeviceManagementModule: IWorkflowModuleConfig = {
        name: "devicemanagement",
        modulePath: PLATFORM.moduleName("modules/workflows/Client/DeviceManagement/DeviceManagementModule"),
        title: "Legacy Device Management",
        moduleType: WorkflowModuleType.Client,
    };
}
